@if (!hasOnlyOneCompany && !dropdownEnabled) {
  <div class="input-container">
    <div class="input-group">
      <input style="height: fit-content; width: 200px" #searchField
        type="text" class="form-control bgnone"
        [placeholder]="'organization.all' | translate | capitalize"
        [resultFormatter]="resultFormatter" [inputFormatter]="inputFormatter" [ngbTypeahead]="search"
        (selectItem)="updateSelectedCompanyBySearch($event.item)"
        [value]="selectedCompanyDisplay" (focusout)="cancelSearch()"
        (keyup)='updateSearchText($event.target);'>
        @if (selectedCompanyDisplay) {
          <span class="input-group-text" role="button" (click)="resetSearch()"
            [title]="'Commands.remove' | translate"
            >
            <i class="far fa-fw fa-times"></i>
          </span>
        }
      </div>
    </div>
  }

  @if (dropdownEnabled) {
    @if (companies) {
      <lib-select #selectdropdown style="height: 40px; width: 300px" (itemChange)="updateSelectedCompany($event)"
        [(item)]="selectedCompanyGuid">
        <option [value]="undefined">{{'organization.all' | translate |
        capitalize}}</option>
        @for (company of companies.results; track company) {
          <option
            [value]="company.guid">
            {{company.searchName}}
          </option>
        }
      </lib-select>
    }
  }
